"use client";

import React from "react";

const images = [
    {
        src: "https://cdn.msu.edu.in/MoU-images/Apollo.webp",
        caption: "MoU with Apollo Hospitals",
    },
    {
        src: "https://cdn.msu.edu.in/MoU-images/Polaris.webp",
        caption: "MoU with Polaris",
    },
    {
        src: "https://cdn.msu.edu.in/MoU-images/IGJA.webp",
        caption: "MoU with IGJA",
    },
    {
        src: "https://cdn.msu.edu.in/MoU-images/Bosch.webp",
        caption: "MoU with Bosch",
    },
    {
        src: "https://cdn.msu.edu.in/MoU-images/B4M.webp",
        caption: "MoU with B4M",
    },
    {
        src: "https://cdn.msu.edu.in/MoU-images/IGJ.webp",
        caption: "MoU with IGJ",
    },

  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/Chai+Point+to+deliver+industry-integrated+education+programs.png",
    caption: "MoU with Chai Point"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/Futred+Innovation+Studios+to+co-create+globally+accredited%2C+industry-aligned+programs.jpg",
    caption: "MoU with Futred Innovation Studios"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/ITD+Education+Pvt.+Ltd.+for+industry-aligned+NSQFNHEQF+programs.png",
    caption: "MoU with ITD Education Pvt. Ltd."
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/MSU+%26+Quess+Corp+Lead+the+Way+in+Workforce+Transformation.png",
    caption: "MoU with Quess Corp"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/MSU+in+collaboration+with+Barbeque+Nation%2C+launched+industry-integrated+hospitality+programs.png",
    caption: "MoU with Barbeque Nation"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/Partnership+with+Nexus+Select+Trust+to+launch+India%E2%80%99s+first+Mall+Management+degree.png",
    caption: "MoU with Nexus Select Trust"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/Patanjali+Japan+Foundation+-+To+create+global+employment+opportunities+_.png",
    caption: "MoU with Patanjali Japan Foundation"
  },
  {
    src: "https://cdn.msu.edu.in/MoU-images/indrustry/Steward+Healthcare+India+to+Power+Skill-to-Career+Pathways+in+Healthcare.png",
    caption: "MoU with Steward Healthcare India"
  }


];

const ImagesIndustry = () => {
    return (
        <section className="w-full bg-white ">
            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {images.map((item, idx) => (
                        <div
                            key={idx}
                            className="relative h-64 sm:h-72 md:h-80 w-full overflow-hidden "
                        >
                            <img
                                src={item.src}
                                alt={item.caption}
                                className="h-full w-full object-cover"
                            />
                            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/80 via-black/60 to-transparent" />
                            <div className="absolute inset-x-0 bottom-0 px-4 pb-3 pt-6">
                                <p
                                    className="text-sm sm:text-base font-semibold text-white drop-shadow-md"
                                    style={{ fontFamily: "saans-regular" }}
                                >
                                    {item.caption}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ImagesIndustry;
